import { Download, BarChartOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React from 'react'
import { Bar } from 'react-chartjs-2'

// 1. Just catch the options prop passed from your parent here
const AdminDashDonut = ({ regionCleint, downloadFile, options }) => {
    
    const chartOptions = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        layout: {
            padding: {
                right: 40
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: "#1e293b",
                titleColor: "#ffffff",
                bodyColor: "#f1f5f9",
                padding: 8,
                cornerRadius: 6,
            }
        },
        scales: {
            x: {
                grid: {
                    color: "rgba(0, 0, 0, 0.04)",
                    drawBorder: false,
                },
                ticks: {
                    color: "#64748b",
                    font: { size: 11, family: "Inter, system-ui, sans-serif" },
                    callback: (value) => value.toLocaleString(),
                }
            },
            y: {
                grid: { display: false },
                ticks: {
                    color: "#334155",
                    font: { size: 11, weight: '500', family: "Inter, system-ui, sans-serif" },
                }
            }
        },
        elements: {
            bar: {
                borderRadius: 4,
                borderSkipped: false,
            }
        },
        // 2. Mix in the parent's onClick configuration directly onto your original object
        onClick: options?.onClick,
        onHover: options?.onHover
    };

const inlineValueLabelsPlugin = {
    id: 'inlineValueLabels',
    afterDatasetsDraw(chart) {
        const { ctx, data } = chart;
        ctx.save();
        
        chart.getDatasetMeta(0).data.forEach((bar, index) => {
            const value = data.datasets[0].data[index];
            if (value === undefined || value === null) return;
            
            const formattedValue = value.toLocaleString();
            const xPos = bar.x + 8; 
            const yPos = bar.y + 4; 
            
            ctx.font = '600 11px Inter, system-ui, sans-serif'; 
            ctx.fillStyle = '#475569'; 
            ctx.textAlign = 'left';
            ctx.fillText(formattedValue, xPos, yPos);
        });
        ctx.restore();
    }
};

    const charts = [
        { 
            title: "Region Wise Client", 
            data: regionCleint, 
            type: "client"
        },
    ];

    return (
        <div className="grid grid-cols-1  gap-4">
            {charts.map((chart, idx) => (
                <div 
                    key={idx} 
                    className="bg-white rounded-2xl border border-slate-100 p-4 "
                    style={{ boxShadow: '0 1px 4px rgba(10,37,64,0.06)' }}
                >
                    <div className="flex justify-between items-center mb-3">
                        <div>
                            <h3 className="text-sm font-semibold text-slate-800 tracking-tight flex items-center gap-2">
                                <BarChartOutlined className="text-slate-400" style={{ fontSize: '1.15rem' }} />
                                {chart.title}
                            </h3>
                        </div>
                    </div>

                    <div className="h-52 w-full">
                        <Bar 
                            data={chart.data} 
                            options={chartOptions} 
                            plugins={[inlineValueLabelsPlugin]} 
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default AdminDashDonut